import { PerPersonReaders, type Role } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const AssignmentsPage = lazyPage(() => import("../people/AssignmentsPage"), "AssignmentsPage");
const EfficiencyPage = lazyPage(() => import("../people/EfficiencyPage"), "EfficiencyPage");
const LoadBoardPage = lazyPage(() => import("../people/LoadBoardPage"), "LoadBoardPage");
const MyAssignedWorkPage = lazyPage(() => import("../people/MyAssignedWorkPage"), "MyAssignedWorkPage");
const OperationsTeamPage = lazyPage(() => import("../people/OperationsTeamPage"), "OperationsTeamPage");
const SkillsPage = lazyPage(() => import("../people/SkillsPage"), "SkillsPage");
const TimeOffPage = lazyPage(() => import("../people/TimeOffPage"), "TimeOffPage");
const WeeklyReportPage = lazyPage(() => import("../people/WeeklyReportPage"), "WeeklyReportPage");
const MachineOperatorsPage = lazyPage(() => import("../people/machineOperators/MachineOperatorsPage"), "MachineOperatorsPage");

export { AssignmentsPage, EfficiencyPage, LoadBoardPage, MyAssignedWorkPage, OperationsTeamPage, SkillsPage, TimeOffPage, WeeklyReportPage };

export const peopleRoutes: AreaRoute[] = [
  { path: "/people/team", allow: PerPersonReaders, element: <OperationsTeamPage /> },
  // Who runs which machine (owner's ask, 2026-10-23; O-R24, Q-O13): per-person readers only.
  { path: "/people/machine-operators", allow: PerPersonReaders, element: <MachineOperatorsPage /> }
];
/** People & load readers: the per-person readers only. Owner, 2026-10-20 (D-O60): Shop Supervisors see only themselves (My work). */
export const PeopleScreenReaders: readonly Role[] = [...PerPersonReaders];
